{
  "AUTOMATION": {
    "HEADER": "Automation",
    "DESCRIPTION": "Automation can replace and streamline existing processes that require manual effort, such as adding labels and assigning conversations to the most suitable agent. This allows the team to focus on their strengths while reducing time spent on routine tasks.",
    "LEARN_MORE": "Learn more about automation",
    "HEADER_BTN_TXT": "Add Automation Rule",
    "LOADING": "Fetching automation rules",
    "ADD": {
      "TITLE": "Add Automation Rule",
      "SUBMIT": "Create",
      "CANCEL_BUTTON_TEXT": "Cancel",
      "FORM": {
        "NAME": {
          "LABEL": "Rule Name",
          "PLACEHOLDER": "Enter rule name",
          "ERROR": "Name is required"
        },
        "DESC": {
          "LABEL": "Description",
          "PLACEHOLDER": "Enter rule description",
          "ERROR": "Description is required"
        },
        "EVENT": {
          "LABEL": "Event",
          "PLACEHOLDER": "Please select one",
          "ERROR": "Event is required"
        },
        "PHASE": {
          "LABEL": "Faza"
        },
        "ORDER": {
          "LABEL": "Rendi",
          "ERROR": "Rendi është i detyrueshëm"
        },
        "CONDITIONS": {
          "LABEL": "Conditions"
        },
        "ACTIONS": {
          "LABEL": "Actions"
        }
      },
      "CONDITION_BUTTON_LABEL": "Add Condition",
      "ACTION_BUTTON_LABEL": "Add Action",
      "API": {
        "SUCCESS_MESSAGE": "Automation rule added successfully",
        "ERROR_MESSAGE": "Could not able to create a automation rule, Please try again later"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "PHASE": "Faza",
        "ORDER": "Rendi",
        "NAME": "Name",
        "DESCRIPTION": "Description",
        "ACTIVE": "Active",
        "CREATED_ON": "Created on",
        "WAIT": "Pritja"
      },
      "404": "No automation rules found",
      "TABS": {
        "ALL": "Të gjitha",
        "INSTANT": "Në ngjarje",
        "DELAYED": "Me vonesë"
      },
      "WAITS": "Pret {duration}"
    },
    "DELETE": {
      "TITLE": "Delete Automation Rule",
      "SUBMIT": "Delete",
      "CANCEL_BUTTON_TEXT": "Cancel",
      "CONFIRM": {
        "TITLE": "Confirm Deletion",
        "MESSAGE": "Are you sure to delete ",
        "YES": "Yes, Delete ",
        "NO": "No, Keep "
      },
      "API": {
        "SUCCESS_MESSAGE": "Automation rule deleted successfully",
        "ERROR_MESSAGE": "Could not able to delete a automation rule, Please try again later"
      }
    },
    "EDIT": {
      "TITLE": "Edit Automation Rule",
      "SUBMIT": "Update",
      "CANCEL_BUTTON_TEXT": "Cancel",
      "API": {
        "SUCCESS_MESSAGE": "Automation rule updated successfully",
        "ERROR_MESSAGE": "Could not update automation rule, Please try again later"
      }
    },
    "CLONE": {
      "TOOLTIP": "Clone",
      "API": {
        "SUCCESS_MESSAGE": "Automation cloned successfully",
        "ERROR_MESSAGE": "Could not clone automation rule, Please try again later"
      }
    },
    "FORM": {
      "EDIT": "Edit",
      "CREATE": "Create",
      "DELETE": "Delete",
      "CANCEL": "Cancel",
      "RESET_MESSAGE": "Changing event type will reset the conditions and events you have added below"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "You need to have atleast one condition to save",
      "CONTACT_CUSTOM_ATTR_LABEL": "Contact Custom Attributes",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Conversation Custom Attributes"
    },
    "ACTION": {
      "DELETE_MESSAGE": "You need to have atleast one action to save",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Enter your message here",
      "TEAM_DROPDOWN_PLACEHOLDER": "Select teams",
      "EMAIL_INPUT_PLACEHOLDER": "Enter email",
      "URL_INPUT_PLACEHOLDER": "Enter URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Zgjidhni kutinë hyrëse të email-it dhe adresën e dërguesit",
      "SUBJECT_INPUT_PLACEHOLDER": "Subjekti i email-it",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Zgjidhni kutinë hyrëse SMS nga e cila do të dërgohet SMS",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Shkruani tekstin e SMS-it",
      "SMS_COUNTER": "{length}/{limit} karaktere, {segments} SMS (para plotësimit të variablave)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Activate Automation Rule",
      "DEACTIVATION_TITLE": "Deactivate Automation Rule",
      "ACTIVATION_DESCRIPTION": "This action will activate the automation rule '{automationName}'. Are you sure you want to proceed?",
      "DEACTIVATION_DESCRIPTION": "This action will deactivate the automation rule '{automationName}'. Are you sure you want to proceed?",
      "ACTIVATION_SUCCESFUL": "Automation Rule Activated Successfully",
      "DEACTIVATION_SUCCESFUL": "Automation Rule Deactivated Successfully",
      "ACTIVATION_ERROR": "Could not Activate Automation, Please try again later",
      "DEACTIVATION_ERROR": "Could not Deactivate Automation, Please try again later",
      "CONFIRMATION_LABEL": "Yes",
      "CANCEL_LABEL": "No"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Could not upload attachment, Please try again",
      "LABEL_IDLE": "Upload Attachment",
      "LABEL_UPLOADING": "Po ngarkohet...",
      "LABEL_UPLOADED": "Successfully Uploaded",
      "LABEL_UPLOAD_FAILED": "Upload Failed"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Value is required",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Ky veprim funksionon vetëm kur faza e rregullit është vendosur në «Para etiketimit».",
      "SKIP_AUTO_LABELING": "Ky veprim funksionon vetëm kur faza e rregullit është vendosur në «Para etiketimit».",
      "MOVE_CONVERSATION_TO_INBOX": "Në një kuti hyrëse email mund të zhvendosen vetëm bisedat me email dhe ato nga chat-i në ueb, e chat-i vetëm nëse kontakti ka adresë email. Përndryshe biseda mbetet aty ku është dhe në vend të kësaj shtohet një shënim privat.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Nis një bisedë të re me kontaktin në kutinë hyrëse të zgjedhur të email-it, i dërgon mesazhin me email dhe e zgjidh bisedën. Kjo ndodh sa herë që ekzekutohet rregulli. Nëse kontakti nuk ka adresë email, nuk dërgohet asgjë dhe në vend të kësaj shtohet një shënim privat.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Nis një bisedë të re me kontaktin në kutinë hyrëse SMS të zgjedhur, i dërgon mesazhin me SMS dhe e zgjidh bisedën. Kjo ndodh sa herë që ekzekutohet rregulli. Mesazhi është tekst i thjeshtë pa bashkëngjitje. Nëse kontakti nuk ka numër telefoni, nuk dërgohet asgjë dhe në vend të kësaj shtohet një shënim privat."
    },
    "NOTICES": {
      "AI_PROMPT": "Çdo vlerësim individual faturohet.",
      "INCOMING_MESSAGES_COUNT": "Kjo i referohet numrit të mesazheve hyrëse në bisedë.",
      "OUTGOING_MESSAGES_COUNT": "Kjo i referohet numrit të mesazheve dalëse në bisedë."
    },
    "PHASE": {
      "BEFORE_LABELING": "Para etiketimit",
      "AFTER_LABELING": "Pas etiketimit"
    },
    "NONE_OPTION": "None",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Incoming Message",
      "OUTGOING": "Outgoing Message",
      "PRIVATE": "Private Note",
      "AI_SUMMARY": "AI Summary"
    },
    "YES_NO_VALUES": {
      "YES": "Po",
      "NO": "Jo"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Mesazh i drejtpërdrejtë në Instagram",
      "FACEBOOK_COMMENT": "Koment në Facebook"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Biseda u krijua",
      "CONVERSATION_UPDATED": "Biseda u përditësua",
      "MESSAGE_CREATED": "Mesazhi u krijua",
      "CONVERSATION_OPENED": "Biseda u hap",
      "CONVERSATION_RESOLVED": "Biseda u zgjidh",
      "PHONE_CALL_FINISHED": "Thirrja përfundoi"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Cakto te një agjent",
      "ASSIGN_TEAM": "Cakto një ekip",
      "ADD_LABEL": "Shto një etiketë",
      "REMOVE_LABEL": "Hiq një etiketë",
      "SEND_EMAIL_TO_TEAM": "Dërgo email te ekipi",
      "SEND_EMAIL_TRANSCRIPT": "Dërgo transkriptin me email",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Dërgo një transkript të detajuar me email",
      "MUTE_CONVERSATION": "Heshto bisedën",
      "SNOOZE_CONVERSATION": "Shty bisedën",
      "RESOLVE_CONVERSATION": "Zgjidh bisedën",
      "OPEN_CONVERSATION": "Hap bisedën",
      "SEND_WEBHOOK_EVENT": "Dërgo ngjarje webhook",
      "SEND_ATTACHMENT": "Dërgo bashkëngjitje",
      "SEND_MESSAGE": "Dërgo një mesazh",
      "ADD_NOTE": "Shto një shënim",
      "CHANGE_PRIORITY": "Ndrysho prioritetin",
      "ADD_SLA": "Shto SLA",
      "SKIP_AUTO_PRIORITY": "Kapërce prioritetin automatik",
      "SKIP_AUTO_LABELING": "Kapërce etiketimin automatik",
      "AUTO_TRANSLATE": "Përkthe mesazhin",
      "AUTO_TRANSLATE_CONVERSATION": "Përkthe bisedën",
      "MOVE_CONVERSATION_TO_INBOX": "Zhvendos bisedën në kutinë hyrëse",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Dërgo mesazh në një bisedë të re",
      "SEND_SMS_IN_NEW_CONVERSATION": "Dërgo SMS në një bisedë të re",
      "STOP_PROCESSING_RULES": "Ndalo përpunimin e rregullave"
    },
    "ATTRIBUTES": {
      "AI_FILTER": "Filtër IA",
      "MESSAGE_TYPE": "Lloji i mesazhit",
      "MESSAGE_CONTAINS": "Përmbajtja e mesazhit",
      "EMAIL": "Email",
      "INBOX": "Kutia hyrëse",
      "CHANNEL_TYPE": "Lloji i kutisë hyrëse",
      "CONVERSATION_LANGUAGE": "Gjuha e bisedës",
      "PHONE_NUMBER": "Numri i telefonit",
      "STATUS": "Statusi",
      "BROWSER_LANGUAGE": "Gjuha e shfletuesit",
      "MAIL_SUBJECT": "Subjekti i email-it",
      "COUNTRY_NAME": "Shteti",
      "MARKETPLACE_COUNTRY": "Shteti i marketplace-it",
      "REFERER_LINK": "Lidhja referuese",
      "ASSIGNEE_NAME": "I caktuari",
      "TEAM_NAME": "Ekipi",
      "PRIORITY": "Prioriteti",
      "CALL_DIRECTION": "Drejtimi i thirrjes",
      "MISSED_CALL": "Thirrje e humbur",
      "MISSED_CALL_COUNT": "Numri i thirrjeve të humbura",
      "MESSAGE_SOURCE_TYPE": "Lloji i burimit të mesazhit",
      "INCOMING_MESSAGE_COUNT": "Numri i mesazheve hyrëse",
      "OUTGOING_MESSAGE_COUNT": "Numri i mesazheve dalëse",
      "LABEL": "Etiketa",
      "EMAIL_RECIPIENTS": "Marrësi i email-it",
      "EMAIL_AUTO_REPLY": "Email-i është përgjigje automatike",
      "ATTACHMENT_EXTENSION": "Prapashtesa e bashkëngjitjes",
      "EXTENSION": "Shtesa e thirrur",
      "WORKING_HOURS": "Brenda orarit të punës",
      "AGENT_REPLIED": "Agjenti ka përgjigjur që nga ndryshimi i statusit"
    },
    "WAIT": {
      "RUN_LABEL": "Ekzekuto veprimet",
      "INSTANT": "Në ngjarje",
      "DELAYED": "Me vonesë",
      "TRIGGER_LABEL": "Prit derisa",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "Një bisedë mbetet në një status",
        "CUSTOMER_UNRESPONSIVE": "Klienti nuk i përgjigjet agjentit",
        "AGENT_UNRESPONSIVE": "Klienti nuk merr përgjigje nga agjenti"
      },
      "STATUS_LABEL": "Statusi",
      "STATUSES": {
        "OPEN": "E hapur",
        "PENDING": "Në pritje",
        "SNOOZED": "E shtyrë",
        "RESOLVED": "E zgjidhur"
      },
      "DELAY_LABEL": "Koha e pritjes",
      "DELAY_ERROR": "Vendosni një pritje nga 1 minutë deri në 30 ditë",
      "DURATION": {
        "MINUTES": "{count} min",
        "HOURS": "{count} orë",
        "DAYS": "{count} ditë"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Veprimet ekzekutohen kur një bisedë ka qenë në statusin {status} për {duration}. Një ndryshim statusi para kësaj i anulon. Etiketat, orari i punës dhe përgjigjet e agjentit kontrollohen kur mbaron pritja.",
        "CUSTOMER_UNRESPONSIVE": "Veprimet ekzekutohen kur klienti nuk është përgjigjur për {duration} pas mesazhit të një agjenti. Përgjigja e klientit i anulon; një mesazh i ri i agjentit e rinis pritjen.",
        "AGENT_UNRESPONSIVE": "Veprimet ekzekutohen kur klienti ka pritur {duration} pa përgjigje nga një agjent. Përgjigja e agjentit i anulon."
      }
    }
  }
}
